import React from 'react';

import { Section, ActionButton, Body, LoadingShimmer } from '@icarros/ids-react';

import { useAdContext } from '../../../store/contexts/ad';
import { useAd } from '../../../store/hooks/useAd';

import { EDIT_ROUTES } from '../../../utils/adEditRoutes';

import { pushSellerPFDashboardEvent } from '../../../../utils/pushToDataLayer';

import { BodyWrapper, DescriptionWrapper, ResumeDetailsWrapper, ResumeTitleWrapper } from './style';

export function AdDescription(): JSX.Element {
  const { currentAd } = useAdContext();
  const { pushToEditForm } = useAd();

  const { texto } = currentAd || {};

  return (
    <ResumeDetailsWrapper>
      <ResumeTitleWrapper>
        <Section size="section_1">descrição do anúncio</Section>
        <ActionButton
          iconName="itaufonts_educacao_uso_consc"
          text="editar"
          variant="secondary"
          weight="small"
          onClick={() => {
            pushSellerPFDashboardEvent('descriçao do anúncio', 'editar');
            pushToEditForm(EDIT_ROUTES.description.name);
          }}
        />
      </ResumeTitleWrapper>
      {currentAd && !texto ? (
        <BodyWrapper>
          <Body size="body_2">Você não adicionou uma descrição do anúncio.</Body>
        </BodyWrapper>
      ) : (
        <LoadingShimmer show={!currentAd} height="80px" width="320px">
          <DescriptionWrapper>
            <Body size="body_2">{texto}</Body>
          </DescriptionWrapper>
        </LoadingShimmer>
      )}
    </ResumeDetailsWrapper>
  );
}
